import React from "react";
import { Card } from "antd";
import { formatAmountCurrency } from "@/utils";
import { useScanQrcodeStore } from "@/store";

const ProductInfo: React.FC<{ className: string }> = ({ className }) => {
  // Replace with your state management solution
  const { stamp_code } = useScanQrcodeStore();
  const { product, company } = stamp_code || {};

  const InfoRow: React.FC<{
    label: string;
    value: React.ReactNode;
    fullWidth?: boolean;
  }> = ({ label, value, fullWidth = false }) => (
    <div className={`grid grid-cols-12 gap-4 mb-3 max-md:text-sm ${fullWidth ? "" : ""}`}>
      <div className={fullWidth ? "col-span-12" : "col-span-5"}>{label}</div>
      {!fullWidth && <div className="col-span-7 text-right text-[#463E37] font-semibold">{value}</div>}
    </div>
  );

  const formatSalesPrice = () => {
    const formattedPrice = formatAmountCurrency(product?.mrp.toString() || '--', company?.currency);
    const unitName = product?.unit?.name || "chiếc";

    return `${formattedPrice} / ${unitName}`;
  };

  // Safe HTML rendering function
  const createMarkup = (html: string) => {
    return { __html: html };
  };

  return (
    <Card title={<div className="text-[#F38020] text-[16px] font-bold">Thông tin sản phẩm</div>} className={className}>
      <div className="py-3">
        <dl>
          <InfoRow label="Tên sản phẩm" value={product?.name || "--"} />

          <InfoRow label="Thương hiệu" value={product?.brand?.name || "--"} />

          <InfoRow label="Giá bán" value={formatSalesPrice() || "--"} />

          <InfoRow label="Mô tả" value="" fullWidth={true} />
          <div
            className="col-span-12"
            dangerouslySetInnerHTML={createMarkup(product?.description || "<span></span>")}
          />
        </dl>
      </div>
    </Card>
  );
};

export default ProductInfo;
